module.exports = __webpack_public_path__ + "img/program-whiteboard.3be51c79.jpg";